<template>
    <div>
        <form @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" class="form">
            <fieldset>

                <div class="form__legend">Kontaktní formulář</div>

                <div class="form__row form--required">
                    <label>Jméno</label>
                    <div class="form__controls">
                        <input type="text" name="name" v-model="form.name" placeholder="Jméno">
                        <div class="form__error" v-html="form.errors.get('name')"></div>
                    </div>
                </div>

                <div class="form__row form--required">
                    <label>Email</label>
                    <div class="form__controls">
                        <input type="email" name="email" v-model="form.email" placeholder="Email">
                        <div class="form__error" v-html="form.errors.get('email')"></div>
                    </div>
                </div>

                <div class="form__row form--required">
                    <label>Telefon</label>
                    <div class="form__controls">
                        <input type="text" name="phone" v-model="form.phone" placeholder="Telefon">
                        <div class="form__error" v-html="form.errors.get('phone')"></div>
                    </div>
                </div>

                <div class="form__row form--required">
                    <label>Zpráva</label>
                    <div class="form__controls">
                        <textarea rows="5" name="message" v-model="form.message" placeholder="Zpráva"></textarea>
                        <div class="form__error" v-html="form.errors.get('message')"></div>
                    </div>
                </div>

                <div class="form__row">
                    <div class="form__controls--no-label">
                        <label class="form__checkbox">
                            <input type="checkbox" name="terms" value="1" class="mr-2" v-model="form.terms" @change="form.errors.clear('terms')">
                            Souhlasím se zpracováním mých osobních údajů
                        </label>
                        <div class="form__error" v-html="form.errors.get('terms')"></div>
                    </div>
                </div>

                <div class="form__controls--no-label">
                    <button type="submit" class="btn btn-primary" :disabled="form.errors.any()">
                        Odeslat
                        <i class="fa fa-fw fa-spinner fa-pulse" v-if="sending"></i>
                        <i class="fa fa-fw fa-chevron-right" v-else></i>
                    </button>
                </div>

            </fieldset>

        </form>
    </div>
</template>

<script>
    import Form from '../vn/Form.js';
    export default {

        data() {
            return {
                form: new Form({
                    name: '',
                    phone: '',
                    email: '',
                    message: '',
                    terms: false
                }),
                sending: false
            }
        },

        methods: {
            onSubmit() {
                this.sending = true;
                this.form.post(url('/contact-form'))
                    .then(response => {
                        this.sending = false;

                        if (response.status !== 'success') {
                            console.log(response);
                            alert('Chyba při odesílání formuláře');
                            return;
                        }

                        swal({
                            title: 'Děkujeme',
                            text: 'na Vaše případné dotazy odpovíme co nejdříve',
                            type: 'success',
                            timer: 5000
                        });
                    })
                    .catch(errors => {
                        this.sending = false;
                        // other than validation error
                        if (errors.status !== 422) {
                            console.log(errors);
                            alert('Chyba při odesílání formuláře');
                        }
                    });
            }
        }
    }
</script>
